<template>
    <div class="comprehensive-inspection">
        <mc-operate-bar>
            <template slot="right">
                <el-tooltip effect="dark" content="刷新" placement="bottom" transition="none">
                    <el-button type="default" size="" @click="this.$_getList" icon="el-icon-refresh" style="margin-right: 10px;"
                        circle></el-button>
                </el-tooltip>
                <el-button type="primary" size="" @click="dialog.upLoad.visible = true" style="margin-left:15px">上传</el-button>
                <el-button type="defalut" size="" @click="$_downloadTool">下载工具</el-button>
            </template>
        </mc-operate-bar>
        <!-- <div class="btn-box">
            <el-button type="primary" size="small" @click="dialog.upLoad.visible = true" style="margin-left:15px">上传</el-button>
            <el-button type="primary" size="small" @click="$_downloadTool">下载工具</el-button>
        </div> -->
        <mc-table ref="mc-table" :table-option="tableOption" v-loading="tableOption.loading">
            <template slot="table-components">
                <el-table-column :prop="tableOption.head[0].prop" :label="tableOption.head[0].label" :width="tableOption.head[0].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        {{ formatDate(scope.row.upload_time) }}
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[1].prop" :label="tableOption.head[1].label" :width="tableOption.head[1].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[2].prop" :label="tableOption.head[2].label" :width="tableOption.head[2].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[3].prop" :label="tableOption.head[3].label" :width="tableOption.head[3].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[4].prop" :label="tableOption.head[4].label" :width="tableOption.head[4].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 100">
                            <el-button size="mini" type="primary" @click="$_analyzeReport(scope.row.id)">分析</el-button>
                        </span>
                        <span v-else-if="scope.row.status == 110" style="color: #909399">分析中..</span>
                        <span v-else-if="scope.row.status == 120">
                            <el-button size="mini" @click="$_gotoReport(scope.row.id)">查看</el-button>
                        </span>
                        <span v-else-if="scope.row.status == 130">
                            <el-button size="mini" type="warning" @click="$_analyzeReport(scope.row.id)">重试</el-button>
                        </span>
                    </template>
                </el-table-column>
            </template>
        </mc-table>
        <mc-pager :pager-option.sync="pager" ref="comprehensive-inspection-pager" @getList="$_getList"></mc-pager>

        <mc-dialog :dialog-option.sync="dialog.upLoad">
            <template slot="content">
                <mc-layout-row label-text="选择文件" :label-width="120" align-column="top" content-align-row="left">
                    <el-button type="primary" @click="$_fileButton">选择文件</el-button>
                    <input type="file" v-show="false" class='selectfile' @change='$_handleFileChange' ref='selectfile' />
                    <mc-label style="margin-left:10px;" icon="el-icon-warning" warn>仅支持.mc格式文件</mc-label>
                </mc-layout-row>
                <mc-label icon="el-icon-document" success v-show="dialog.upLoad.data.fileName">
                    {{dialog.upLoad.data.fileName}}
                </mc-label>
                <mc-layout-row :label-show="false">
                    <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="dialog.upLoad.data.text"></el-input>
                </mc-layout-row>
            </template>
            <template slot="footer">
                <el-button icon="el-icon-upload2" type="primary" @click="$_postAwrReport" :loading="dialog.upLoad.state.isLoading">上传</el-button>
            </template>
        </mc-dialog>
    </div>
</template>

<script>
    export default {
        name: "comprehensive-inspection",
        data() {
            return {
                pager: {
                    page: 1,
                    per_page: 10,
                    per_pages: [10, 20, 30, 40, 50],
                    total: 0,
                },
                tableOption: {
                    loading: false,
                    index: {
                        disable: true,
                    },
                    head: [{
                            prop: "upload_time",
                            label: "采集数据上传时间",
                        },
                        {
                            prop: "db_type",
                            label: "数据库类型",
                        },
                        {
                            prop: "os_type",
                            label: "操作系统",
                        },
                        {
                            prop: "description",
                            label: "备注",
                        },
                        {
                            prop: "status",
                            label: "操作",
                            width: "100"
                        }
                    ],
                    data: [],
                },
                dialog: {
                    upLoad: {
                        visible: false,
                        title: "上传数据",
                        state: {
                            isLoading: false,
                        },
                        style: {
                            showConfirm: false,
                            showCancel: false,
                            width: '500px'
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.visible = true;
                            },
                        },
                        data: {
                            text: "",
                            file: "",
                            fileName: ""
                        },
                    }
                },
            }
        },
        methods: {
            formatDate,
            $_getList: async function () {
                this.tableOption.loading = true;
                let params = {
                    page: this.pager.page,
                    per_page: this.pager.per_page,
                };
                let data = await this.$api.userComprehensiveInspection.getList.call(this, params);
                if (data !== false) {
                    this.tableOption.data = data.items;
                    this.pager.total = data.total;
                    this.tableOption.data = data.items;
                }
                this.tableOption.loading = false;
            },
            $_fileButton() {
                this.$refs.selectfile.click();
            },
            $_handleFileChange() {
                let inputDom = this.$refs.selectfile;
                this.dialog.upLoad.data.file = inputDom.files[0];
                this.dialog.upLoad.data.fileName = inputDom.files[0].name;
            },
            $_analyzeReport: async function (id) {
                let params = {
                    report_id: id
                };
                let data = await this.$api.userComprehensiveInspection.generateReport.call(this, params);
                if (data !== false) {
                    this.$_getList();
                }
            },
            $_postAwrReport: async function () {
                let formData = new FormData();
                formData.append("file", this.dialog.upLoad.data.file);
                formData.append("description", this.dialog.upLoad.data.text);
                let data = await this.$api.userComprehensiveInspection.postFile.call(this, formData);
                if (data !== false) {
                    this.dialog.upLoad.visible = false;
                    this.$_getList();
                    this.$message.success('上传成功!')
                }
            },
            $_gotoReport(id) {
                this.$router.push({
                    name: 'user-inspection-report',
                    params: {
                        report_id: id
                    }
                });
            },
            $_downloadTool() {
                this.$router.push({
                    name: "user-download-tool"
                })
            },
        },
        mounted() {
            this.$_getList();
        },
        watch: {
            pager: {
                deep: true,
                handler: function () {
                    this.$_getList();
                },
            },
        }
    }
</script>

<style lang="less" scoped>
    .comprehensive-inspection {
        width: 100%;

        .btn-box {
            display: flex;
            flex-direction: row-reverse;
            margin-right: 10px;
            padding: 10px 10px 15px 0;
        }

        .el-dialog {
            .site-item {
                display: inline-flex;
                width: 100%;
                margin-bottom: 20px;

                label {
                    width: 65px;
                    text-align: left;
                }

                .site-input {
                    flex: 1;
                    padding-left: 10px;
                }
            }
        }
    }
</style>